const RULE_TYPE_LABELS = {
  EXACT_SCORE: 'Точный счёт',
  SCORE_DIFFERENCE: 'Точная разница',
  CORRECT_WINNER: 'Победитель',
  EXACT_MATCH: 'Точное совпадение',
  PARTIAL_MATCH: 'Частичное совпадение',
};

export function formatMatchedRuleType(ruleType) {
  if (!ruleType) return 'Нет совпадения';
  return RULE_TYPE_LABELS[ruleType] || ruleType;
}

export function formatBreakdownText(breakdown) {
  if (!breakdown) return '';
  if (!breakdown.matchedRuleType) return 'Нет совпадения';
  const label = formatMatchedRuleType(breakdown.matchedRuleType);
  const points = breakdown.rulePoints ?? breakdown.totalScore ?? 0;
  return `${points} ${pluralizePoints(points)} за ${label}`;
}

export function isLegacyRuleType(ruleType) {
  return ruleType === 'EXACT_MATCH' || ruleType === 'PARTIAL_MATCH';
}

function pluralizePoints(n) {
  const abs = Math.abs(n) % 100;
  const lastDigit = abs % 10;
  if (abs > 10 && abs < 20) return 'очков';
  if (lastDigit > 1 && lastDigit < 5) return 'очка';
  if (lastDigit === 1) return 'очко';
  return 'очков';
}
